<a class="marv_link"
    [class.secondary]="this.colorButton === 'secondary'"
    [class.blue]="this.colorButton === 'blue'"
    [class.red]="this.colorButton === 'red'"
    [class.green]="this.colorButton === 'green'"
    [class.orange]="this.colorButton === 'orange'"
    [class.purple]="this.colorButton === 'purple'"
    [class.marvesting]="this.colorButton === 'marvesting'"
    (click)="this.openLink()"
    >
    <ng-content></ng-content>
</a>